import React from 'react'

export const Loading = () => {
    return (
        <div className="loading">
            <div>
                <img src="./images/favicon.png" style={{width: 80, margin: -10+'px auto'}} alt="Logo"></img>
                <div className="spinner">
                </div>
                <p>Aquí encontrarás un buen trabajo.</p>
            </div>
        </div>
    )
}
